import styled from "styled-components";

const TidalDashboardEbayViewsLogWrapper = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 13px;
`;

const InfoLog = styled(TidalDashboardEbayViewsLogWrapper)`
  color: ${(props) => props.theme.colors.text[0]};
`;
const ErrorLog = styled(TidalDashboardEbayViewsLogWrapper)`
  color: ${(props) => props.theme.colors.button[1]};
`;
const SuccessLog = styled(TidalDashboardEbayViewsLogWrapper)`
  color: ${(props) => props.theme.colors.tags[0]};
`;

interface ITidalDashboardEbayViewsLog {
  type: string;
  text: string;
}

const TidalDashboardEbayViewsLogElement = ({
  type,
  text,
}: ITidalDashboardEbayViewsLog): JSX.Element => {
  if (type === "info") {
    return <InfoLog>{text}</InfoLog>;
  }
  if (type === "error") {
    return <ErrorLog>{text}</ErrorLog>;
  }
  if (type === "success") {
    return <SuccessLog>{text}</SuccessLog>;
  }
};

export default TidalDashboardEbayViewsLogElement;
